import {
  func, bool, string,
} from 'prop-types'
import React, { PureComponent } from 'react'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import FormGroup from '@active/react-ui/FormGroup'
import Form, { FormConsumer } from '@active/react-ui/Form'
import Identity from '@active/react-utils/components/Identity'

import I18nMessage from '../I18nMessage'
import ActiveConsents from '../AgreementGroups'

import './WaiverContent.scss'

class WaiverContent extends PureComponent {
  static propTypes = {
    handleReagreeWaiverSubmit: func.isRequired,
    handleBack: func.isRequired,
    isBack: bool.isRequired,
    showReagreeWaiverError: bool,
    resetAgrees: bool.isRequired,
    handleReagreeWaiverCheckboxChange: func.isRequired,
    selectedCountryCode: string,
    Body: func,
    Footer: func,
  }

  static defaultProps = {
    showReagreeWaiverError: false,
    selectedCountryCode: undefined,
    Body: Identity,
    Footer: Identity,
  }

  formRef

  handleSubmit = () => {
    const { handleReagreeWaiverSubmit } = this.props
    const errorMsg = this.Sub && this.Sub.agreementValidator()
    if (!errorMsg) {
      handleReagreeWaiverSubmit()
    }
  }

  triggerSubmit = () => {
    this.formRef.submitForm()
  }

  render() {
    const {
      selectedCountryCode, Body, Footer,
      handleReagreeWaiverSubmit, handleReagreeWaiverCheckboxChange,
      handleBack, isBack, resetAgrees, ...rest
    } = this.props

    return (
      <Identity>
        <Body>
          <Form onSubmit={this.handleSubmit} className="passport-content waiver-content">
            <div className="passport-content-body">
              <FormGroup name="waiver-groups" withoutLayout>
                <div className="passport-ui-app__subTitle">
                  <I18nMessage id="passport.waiver.terms.notice" />
                </div>
                <ActiveConsents
                  onRef={node => { this.Sub = node }}
                  name="reagree"
                  selectedCountryCode={selectedCountryCode}
                  resetAgrees={resetAgrees}
                  handleCheckboxChange={handleReagreeWaiverCheckboxChange}
                  isSignin
                  isRequired
                  errorMode="alert"
                  {...rest}
                />
              </FormGroup>
            </div>
            <FormConsumer>
              {({ form }) => {
                this.formRef = form
                return null
              }}
            </FormConsumer>
          </Form>
        </Body>
        <Footer>
          <ButtonGroup horizontal className="passport-content-footer waiver-button-group">
            <Button type="super" onClick={this.triggerSubmit}>
              <I18nMessage id="passport.common.btn.next" />
            </Button>
            {isBack && (
              <Button type="secondary" onClick={handleBack}>
                <I18nMessage id="passport.waiver.terms.backToCountry" />
              </Button>
            )}
          </ButtonGroup>
        </Footer>
      </Identity>
    )
  }
}

export default WaiverContent
